export default __webpack_public_path__ + "static/media/contactUs.21892424.svg";